export enum TaskCallColor {
  Danger = 'danger',
  Default = '',
  Primary = 'primary',
}
